export function CheckinTrainingPage() {
  return (
    <div style={{ width: '100%', height: 'calc(100vh - 60px)', overflow: 'hidden' }}>
      <iframe
        src="/checkin-process-training.html"
        title="Check-In Process Training"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    </div>
  );
}
